import { LiquidUnit } from "@tandemdiabetes/sugarmate-api-react-client"

interface Properties {
  sliderStep: number;
  inputStep: number;
  min: number;
  max: number;
}

export const inputPropertiesByUnit: Record<LiquidUnit, Properties> = {
  [LiquidUnit.Milliliters]: {
    sliderStep: 50,
    inputStep: 1,
    min: 0,
    max: 4000,
  },
  [LiquidUnit.Liters]: {
    sliderStep: 0.1,
    inputStep: 0.01,
    min: 0,
    max: 4,
  },
  [LiquidUnit.FluidOunces]: {
    sliderStep: 2,
    inputStep: 0.1,
    min: 0,
    max: 128,
  },
  [LiquidUnit.Cups]: {
    sliderStep: 0.25,
    inputStep: 0.01,
    min: 0,
    max: 16,
  },
  [LiquidUnit.Pints]: {
    sliderStep: 0.25,
    inputStep: 0.01,
    min: 0,
    max: 8,
  },
}
